<!-- =========================================================================================
  File Name: BookEditTabInformation.vue
  Description: Book Edit Information Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="board-edit-form">
    <!-- Content Row -->
    <div class="vx-row"> 
      <div class="vx-col w-full">
        <form @submit.prevent>
            <vs-input name="title" label-placeholder="제목" v-model="board_data.title" v-validate="'required'" class="w-full mb-6" />
            <vs-input name="writerName" label-placeholder="작성자" v-model="board_data.writerName" v-validate="'required'" class="w-full mb-6" />
            <div class="email-compose">
              <editor-tiptap :description="board_data.content" :menubar="true" :readOnly="false" @editorContent="content"></editor-tiptap>
            </div>

            <!-- POST ATTACHMENTS -->
            <div class="flex flex-col" v-if="attach_data.length">
              <div class="">
                <div class="mail__attachment" v-for="(attachment, index) in attach_data" :key="index">
                  <vs-chip color="primary" class="px-4 py-2 mr-3" @click="deleteAttach(attachment)" closable>{{ attachment.realName }}</vs-chip>
                </div>
              </div>
            </div>
            <!-- /POST ATTACHMENTS -->

            <!-- File -->
            <vs-upload 
            ref="uploadFileInput"
            @change="updateCurrFile"
            multiple 
            text="첨부파일" 
            :show-upload-button="false" 
            class="compose-mail-attachment" />
        </form>
      </div>
    </div>

    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button class="ml-auto mt-2" @click="confirmSaveChanges" :disabled="!validateForm">저장</vs-button>
          <vs-button class="ml-4 mt-2" type="border" color="warning" @click="$router.go(-1)">취소</vs-button>
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
 
import { fetchData, postData, putData } from '@/api/module'

export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data () {
    return { 
      boardEntrySeq: this.$route.params.boardEntrySeq,
      board_data: JSON.parse(JSON.stringify(this.data)),
      attach_data: [],
      deleteAttachList: [],
      inputFilesxList: [],
      boardAttachList : [],
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.30
      }
    }
  },
  computed: {
    validateForm () {
      return !this.errors.any()
    }
  },
  methods: {
    content (value) {
      this.board_data.content = value
    },
    deleteAttach (attachment) {
      this.attach_data.splice(this.attach_data.indexOf(attachment), 1)
      this.deleteAttachList.push(attachment.boardAttachSeq)
    },
    confirmSaveChanges () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: '게시글 수정',
        text: '저장 하시겠습니까?',
        accept: this.saveChanges,
        acceptText: '저장'
      })
    },
    updateCurrFile () {
      // console.log(this.$refs.uploadFileInput.filesx)
      this.inputFilesxList = this.$refs.uploadFileInput.filesx
      // console.log(this.inputFilesxList)
    },
    async uploadFile (file) { // 파일업로드
      try {
        const formData = new FormData()

        formData.append('file', file)

        for (const key of formData.entries()) {
          // console.log(`${key}`)
        }

        const { data } = await postData('uploadFile', formData, { 
          headers : { 
            'Content-Type': 'multipart/form-data'
          }
        })

        const newObject = {
          realName : data.data.realName,
          fileName : data.data.fileName,
          contentType : data.data.contentType,
          size : data.data.size
        }
        this.boardAttachList.push(newObject)

      } catch (error) {
        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        }) 
      }
    },
    async saveChanges () {
      if (!this.validateForm) return

      try {
        for (let i = 0; i < this.inputFilesxList.length; i++) {
          const file = this.inputFilesxList[i]
        
          const removeFlag = file.remove
          if (!removeFlag) {
            await this.uploadFile(file)
          }

        }

        const { data } = await putData('board', {
          boardEntrySeq : this.board_data.boardEntrySeq,
          boardSeq : this.board_data.boardSeq,
          title : this.board_data.title,
          writerID : this.board_data.writerID,
          writerName : this.board_data.writerName,
          writerEmail : this.board_data.writerEmail,
          content : this.board_data.content,
          boardAttachList : this.boardAttachList,
          deleteAttachList : this.deleteAttachList
        })
        // console.log(data)
        const boardEntrySeq = this.board_data.boardEntrySeq
        this.$router.push(`/board/board-view/${boardEntrySeq}`)
        this.showSaveChangesSuccess()

      } catch (error) {
        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        }) 
      }
    },
    showSaveChangesSuccess () {
      this.$vs.notify({
        color: 'success',
        title: '게시글 수정',
        text: '저장 되었습니다.'
      })
    },
    async fetch_attach_data () {
      try {
        const { data } = await fetchData(`board/attach/${this.boardEntrySeq}`)
        this.attach_data = data.list

      } catch (error) {

        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        }) 
      }
    }
  },
  created () {
    this.fetch_attach_data()
  }
}
</script>
<style>
.editor__content { 
  overflow: auto !important;
  border-right: 1px solid #ccc !important;
  border-bottom: 1px solid #ccc !important;
  border-left: 1px solid #ccc !important;
  height: 450px !important;
}
.con-img-upload .con-input-upload{
  height: 2.5rem;
  width: 100%;
  margin: 0;
}

.con-img-upload .img-upload {
  margin: 0;
  margin-bottom: .5rem;
  margin-right: 1.5rem;
}
</style>